/**
 * Names of all script functions.
 *
 * @module
 */

/** Script function type for `0x1::aptos_governance::create_proposal`. */
export const create_proposal =
  "0x1::aptos_governance::create_proposal" as const;

/** Script function type for `0x1::aptos_governance::vote`. */
export const vote = "0x1::aptos_governance::vote" as const;
